import { ValidationError, LoadingState } from '../commonTypes'

export interface GetChecklistParams {
  endIndex: number
  startIndex: number
}

export interface IncomingChecklistItem {
  id: number
  title: string
  description: string
  pageName: string
  departmentName: string
  departmentId: number
  type: string
  sectionId: null
  sectionName: null
  userName: string
  createdDate: null
  updatedDate: number
}

export interface IncomingCheckList {
  size: number
  list: IncomingChecklistItem[]
}

export enum CurrentChecklistInfoSettingsPage {
  checkListInfoSettings = 'Checklist Info Settings',
  addNewPage = 'Add New Page',
  editPage = 'Edit Page',
}

// used in other components also. CHANGE WITH CAUTION!!!
export interface IncomingEmpDepartment {
  departmentId: number
  departmentName: string
  supportManagementFlag: boolean
  allocationSupportFlag: boolean
}

export interface CheckListSliceState {
  isLoading: LoadingState
  error: ValidationError
  incomingChecklist: IncomingCheckList
  checklistParams: GetChecklistParams
  empDepartments: IncomingEmpDepartment[]
  checkListInfoSettingsPageToggle: CurrentChecklistInfoSettingsPage
  editThisPage: IncomingChecklistItem
  checklistInfoSettingsParams: GetChecklistParams
  clickedChecklistTitle: IncomingChecklistItem // this is for the clicked checklist item
}

export interface AddEditPageTemplateProps {
  title: string
  setTitle: React.Dispatch<React.SetStateAction<string>>
  checklistName: string
  setChecklistName: React.Dispatch<React.SetStateAction<string>>
  department: string
  setDepartment: React.Dispatch<React.SetStateAction<string>>
  description: string
  setDescription: React.Dispatch<React.SetStateAction<string>>
  showEditor: boolean
  setFinalBtnEnabled: React.Dispatch<React.SetStateAction<boolean>>
}

export interface AddEditDispatchProps {
  postSuccessApi: () => void
  postFailApi: () => void
}

export interface OutgoingAddPage {
  departmentId: number
  description: string
  pageName: string
  title: string
  type: string
}
